import { GenderExpressionFE } from "../../constants/types/acf";

export enum Screens {
    Intro,
    SelectSuburb,
    WhoFor,
    Age,
    About,
    Results,
    GenderExpression,
    SupportRequirements,
}

export const screenOrder = [
    Screens.Intro,
    Screens.SelectSuburb,
    Screens.WhoFor,
    Screens.Age,
    Screens.GenderExpression,
    Screens.About,
    Screens.SupportRequirements,
    Screens.Results,
];

export type AssessmentState = {
    currentScreen: Screens;
    target: undefined | "MYSELF" | "SOMEONE_ELSE";
    suburb: string;
    showselection : number;
    newsuburbname: string;
    age: string;
    lgbtq: undefined | boolean;
    atsi: undefined | boolean;
    gender_identity: undefined | GenderExpressionFE;
    specific_to_gender: undefined | boolean;
    multicultural: undefined | boolean;
    conditions: string[];
    situations: string[];
    communities: string[];
    active_community: string | undefined;
};
